const checkSelectionActive = () => {
  if (window === undefined) return;
  const selection = window.getSelection();

  return selection && selection.type === 'Range';
};

export default checkSelectionActive;
